<template>
  <v-flex class="tables-layout">
    <table-layout>
      <template v-slot:title>
        개인실적 (합계)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          :headers="getHeader(mineSumHeader)"
          :items="mineSumList"
          no-data-text="조회된 목록이 없습니다"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.cnt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
    <table-layout>
      <template v-slot:title>
        개인실적 (상세)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          :headers="getHeader(mineDetailHeader)"
          :items="mineDetailList"
          :items-per-page="-1"
          no-data-text="조회된 목록이 없습니다"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.executionDate="{ value }">
            <div>{{ setDashDate(value) }}</div>
          </template>
          <template v-slot:item.maturityDate="{ value }">
            <div>{{ setDashDate(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.prevLoanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.repayAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeBaseAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeRate="{ value }">
            <div v-if="isUser">-</div>
            <div v-else>{{ value }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
  </v-flex>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import TableMixin from "@/mixin/TableMixin";
import {LOAN_PERFORMANCE_MINE_DETAIL_TABLE, LOAN_PERFORMANCE_MINE_SUM_TABLE} from "@/util/TableHeaders";
import DateMixin from "@/mixin/DateMixin";
import _ from "lodash";
import {mapGetters} from "vuex";

export default {
  name: "LoanPerformanceMineDetail",
  components: {TableLayout},
  props: ["data", "loading"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      mineSumHeader: LOAN_PERFORMANCE_MINE_SUM_TABLE,
      mineDetailHeader: LOAN_PERFORMANCE_MINE_DETAIL_TABLE,
      mineSumList: [],
      mineDetailList: []
    }
  },
  computed: {
    ...mapGetters("login", {
      "isUser": "isUser"
    })
  },
  watch: {
    data(value) {
      if (!_.isEmpty(value)) {
        this.mineSumList = [_.cloneDeep(value.performanceSum)];
        this.mineDetailList = _.cloneDeep(value.performance);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.tables-layout {
  height: 65vh;
  max-height: 800px;
  overflow-y: auto;
  .data-table-layout {
    padding: 20px 10px;
    border: 1px solid #222;
  }
}
</style>